import { FC, useEffect, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { lpResponsiveStyles, SYDM2_SLUG } from "./constants";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { FrontMeService } from "../../../../lib/service/client/FrontMeService";
import {
  FrontProjectService,
  MonumentNameInfo,
} from "../../../../lib/service/client/FrontProjectService";

const useStyles = makeStyles((theme) => {
  const stoneMonumentArea = lpResponsiveStyles(theme, (baseWidth) => ({
    height: `calc(${baseWidth} * 0.9 * 1.190201729)`,
    margin: `calc(${baseWidth} * 0.04) 0`,
  }));
  const nameArea = lpResponsiveStyles(theme, (baseWidth) => ({
    width: `calc(${baseWidth} * 0.9)`,
    height: `calc(${baseWidth} * 0.9 * 1.190201729 * 0.5)`,
    top: `calc(${baseWidth} * 1.190201729 * 0.38)`,
  }));
  const arrowArea = lpResponsiveStyles(theme, (baseWidth) => ({
    color: "white",
    textAlign: "center",
    position: "absolute",
    width: `calc(${baseWidth} * 0.9)`,
    bottom: `calc(${baseWidth} * 1.190201729 * -0.01)`,
    opacity: "0.7",
  }));
  const subText = lpResponsiveStyles(theme, (baseWidth) => ({
    fontFamily: '"ヒラギノ明朝 ProN", "Hiragino Mincho ProN", sans-serif',
    color: "white",
    textAlign: "right",
    right: "6%",
    position: "absolute",
    fontSize: "10px",
    width: `calc(${baseWidth} * 0.9)`,
    bottom: `calc(${baseWidth} * 1.190201729 * 0.02)`,
    opacity: "0.7",
  }));
  const nameItem = lpResponsiveStyles(theme, (baseWidth) => ({
    fontSize: `calc(${baseWidth} * 0.027)`,
  }));
  return {
    root: {
      backgroundImage: "url(/img/lp/stone_monument.png)",
      backgroundSize: "100%",
      position: "relative",
      ...stoneMonumentArea,
    },
    nameArea: {
      position: "absolute",
      maskImage:
        "linear-gradient( to bottom,rgba(0,0,0,0) 0%,rgba(0,0,0,1) 10%,rgba(0,0,0,1) 90%,rgba(0,0,0,0) 100% )",
      padding: "0 3% 0 2%",
      overflow: "scroll",
      ...nameArea,
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    nameList: {
      margin: "20px 0",
      display: "flex",
      justifyContent: "flex-start",
      flexWrap: "wrap",
    },
    nameItem: {
      fontFamily: '"ヒラギノ明朝 ProN", "Hiragino Mincho ProN", sans-serif',
      width: "32%",
      margin: "2% 0.5%",
      lineBreak: "anywhere",
      textAlign: "center",
      opacity: "0.7",
      color: "white",
      "&.mine": {
        opacity: "1",
        textShadow:
          "0 0 1px rgba(255,255,0,0.7), " +
          "0 0 10px rgba(226,237,79,0.7), " +
          "0 0 20px rgba(226,237,79,0.7), " +
          "0 0 30px rgba(226,237,79,0.7), " +
          "0 0 40px rgba(226,237,79,0.4), " +
          "0 0 50px rgba(226,237,79,0.4), " +
          "0 0 60px rgba(226,237,79,0.4), " +
          "0 0 70px rgba(226,237,79,0.2), " +
          "0 0 80px rgba(226,237,79,0.2), " +
          "0 0 90px rgba(226,237,79,0.2)",
      },
      ...nameItem,
    },
    arrowArea,
    subText,
  };
});

const meService = new FrontMeService();
const projectService = new FrontProjectService();

type Props = {};
export const SpStoneMonument: FC<Props> = (props: Props) => {
  const [monumentNames, setMonumentNames] = useState<MonumentNameInfo[]>([]);
  const [monumentNameIds, setMonumentNameIds] = useState<string[]>([]);
  useEffect(() => {
    const getInfos = async () => {
      await projectService.getMonumentNameInfos(
        SYDM2_SLUG,
        setMonumentNames,
        () => {
          setMonumentNames([]);
        }
      );
      await meService.monumentNameIds(
        SYDM2_SLUG,
        setMonumentNameIds,
        (_) => {
          setMonumentNameIds([]);
        },
        () => {
          setMonumentNameIds([]);
        }
      );
    };
    getInfos();
  }, []);
  const classes = useStyles(props);
  return (
    <div className={classes.root}>
      <div className={classes.nameArea}>
        <div className={classes.nameList}>
          {monumentNames.map((monumentName, index) => {
            const monumentState = monumentNameIds.includes(monumentName.id)
              ? "mine"
              : "";
            return (
              <div
                className={`${classes.nameItem} ${monumentState}`}
                key={index}
              >
                {monumentName.monument_name}
              </div>
            );
          })}
        </div>
      </div>
      <div className={classes.arrowArea}>
        <ExpandMoreIcon style={{ fontSize: 40 }} />
      </div>
      <div className={classes.subText}>応援順</div>
    </div>
  );
};
